<div class="container">
    <div class="offset-sm-1 col-sm-10 pt-5 webview text-center" [@flyInOut]="'in'">
    <h1 class="text-center font-weight-normal-calibre questxt">{{question}}</h1>
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt" *ngIf="!isRenewal">{{question_q1}}</h1>
    <div class="col-sm-6 col-md-6 col-xl-4 m-auto px-0 text-left">
        <div class="form-group row">
            <label class="col-sm-5 col-form-label font18">Adults (18+)</label>
            <div class="col-sm-7 mt-1">
                <!-- <select [(ngModel)]="adults" (change)="getAdults($event)" class="dropdown-toggle form-control">
                    <option *ngFor="let adult of hgAdults" value={{adult}}>{{adult}}</option>
                </select> -->
                <ng-select
                    [items]="hgAdults"
                    placeholder="Select"
                    [searchable]="false" [clearable]="false"
                    (change)="getAdults(adults);" [(ngModel)]="adults">
                </ng-select>
            </div>
        </div>
        <div class="form-group row">
            <label class="col-sm-5 col-form-label font18">Children (0-17)</label>
            <div class="col-sm-7 mt-1">
                <!-- <select [(ngModel)]="children" (change)="getChildren($event)" class="dropdown-toggle form-control">
                    <option *ngFor="let children of hgChildren" value={{children}}>{{children}}</option>
                </select> -->
                <ng-select
                    [items]="hgChildren"
                    placeholder="Select"
                    [searchable]="false" [clearable]="false"
                    (change)="getChildren(children);" [(ngModel)]="children">
                </ng-select>
            </div>
        </div>
    </div>
    <button  *ngIf="showbutton"  class="btn next mr-2 ml-2 disabledButton mt-4 font22 text-uppercase" [ngClass]="{'sectbtn': user_bot}" (click)="next();">Next</button>
    <div *ngIf="showTip" class="mt-5">
        <div class="m-auto col-sm-10 col-md-6 col-xl-6 blockbg boxclr text-center">
            <img src="assets/images/flash.png" class="mb-1" />
            <p class="text-center tiphead">TIP OF THE DAY</p>
            <p class="text-center tipmes">{{questionObj && questionObj.renewal_tip}}</p>
            <!-- <p class="text-center font-weight-bold">TIP OF THE DAY<br>
        <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
    </div>
</div>
</div>
<div class="container mobileview mt-4 px-0" [attr.id]="questionObj._id">
        <div class="d-flex h-100 row col-sm-12 pr-0">
                <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-9 col-9 px-0 my-auto">
            <div class="arrow_box" >
                <h1 class="questionMob text-left">{{question}}</h1>
            </div>
        </div>
    </div>
    <div class="row col-12 m-auto">
        <div class="form-group col-12 px-0 mt-2 d-flex flex-wrap">
                <label class="col-5 col-form-label text-right">Adults (18+)</label>
            <div class="col-sm-7 col-7 px-0 mt-1">
                <!-- <select [(ngModel)]="adults" (change)="getAdults($event)" class="dropdown-toggle form-control">
                    <option *ngFor="let adult of hgAdults" value={{adult}}>{{adult}}</option>
                </select> -->
                <ng-select
                    [items]="hgAdults"
                    placeholder="Select"
                    [searchable]="true" [clearable]="false"
                    (change)="getAdults(adults);" [(ngModel)]="adults">
                </ng-select>
            </div>
        </div>
        <div class="form-group col-12 px-0 d-flex flex-wrap" style="margin-bottom:6px !important">
                <label class="col-5 col-form-label text-right">Children (0-17)</label>
            <div class="col-7 px-0 mt-1">
                <!-- <select [(ngModel)]="children" (change)="getChildren($event)" class="dropdown-toggle form-control">
                    <option *ngFor="let children of hgChildren" value={{children}}>{{children}}</option>
                </select> -->
                <ng-select
                    [items]="hgChildren"
                    placeholder="Select"
                    [searchable]="true" [clearable]="false"
                    (change)="getChildren(children);" [(ngModel)]="children">
                </ng-select>
            </div>
        </div>
        <br />
        <div style="width:97% !important; text-align: right;">
            <div *ngIf="user_bot" class="ash_box text-right mt-2" >
                <h1 class="ansMob text-right" *ngIf="adults">Adults (18+): {{adults}}</h1>
                <h1 class="ansMob text-right">Children (0-17): {{children}}</h1>
            </div>
        </div>
        <!-- <br/>
        <div class="col-sm-10 text-left" *ngIf="showTyping">
            <img src="assets/images/typing-animated-gif-1.gif"/>
        </div> -->
    </div>
    <!-- <div class="d-flex h-100 row col-sm-12 pr-0" *ngIf="showTyping">
        <div class="justify-content-center align-self-center  col-sm-3 col-3 pl-0">
            <img style="width:100%;" src="assets/images/signimg.jpg" />
        </div>
        <div class="col-sm-2 col-2 px-0 my-auto">
            <div class="arrow_box">
               <img class="p-2 pl-2 ml-1" src="assets/images/typing-animated-gif-4.gif" />
            </div>
        </div>
    </div> -->
    <div *ngIf="showTip" class="col-12 m-auto">
        <div class="m-auto col-sm-10 col-md-6 col-xl-4 blockbg boxclr">
            <img src="assets/images/flash.png" class="mb-1" style="margin-left:48%" />
            <p class="text-center tiphead">TIP OF THE DAY</p>
            <p class="text-center tipmes">{{questionObj.tip}}</p>
            <!-- <p class="text-center font-weight-bold">TIP OF THE DAY<br>
                <a class="font-weight-normal">{{questionObj.tip}}</a></p> -->
        </div>
    </div>
</div>
<!-- <div class="btm-process webview">
    <div class="text-center" *ngIf="!messagetype">
      <span><img src="assets/images/active14.png"></span>
      <h4 class="clr333 processtxt">15% Completed</h4>
    </div>
    <div class="text-center" *ngIf="messagetype">
        <span><img src="assets/images/active10.png"></span>
        <h5 class="clr333 processtxt">50% Completed</h5>
      </div>
  </div> -->